import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button, message, notification, Spin } from "antd";
import TextBox from "../components/ReportFormGenerator/TextBox/TextBox";
import liracrypt from "../components/Liracrypt/liracrypt";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../components/ApiErrorComp/SessionError";
import { LoadingOutlined } from "@ant-design/icons";
import { Select, Card } from "antd";
import DemoBlock from "./DemoBlock";

function LineAttendance({ lid, selectedName }) {
  const buttonStyle = {
    fontWeight: "700",
    color: "#fff",
    border: "none",
    width: "100%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    marginRight: "20px",
    marginLeft: "20px",
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 30, color: "#fff" }} spin />
  );

  const antIconHeader = (
    <LoadingOutlined style={{ fontSize: 40, color: "#fff" }} spin />
  );

  const [type, setType] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [visible, setVisible] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [header, setHeader] = useState("");

  const [form] = Form.useForm();
  const [Fillform] = Form.useForm();

  const [selectedLid, setSelectedLid] = useState(null);
  const [loadLineAccess, setLoadLineAccess] = useState(null);
  const [selectName, setSelectName] = useState(null);
  const [notContent, setNotContent] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [empName, setEmpName] = useState(null);
  const [rfidValue, setRfidValue] = useState(null);
  const [yccCatValue, setYccCatValue] = useState(null);
  const [ojtStValue, setojtStValue] = useState(null);



  const [inValue, setInValue] = useState(null);
  const [outValue, setOutValue] = useState(null);

  const fetchLineAccess = () => {
    liracrypt
      .get("/attendance/scan/access", {})
      .then((res, req) => {
        
        if (res.status === 204) {
          setNotContent(true);
        }
        setLoadLineAccess(res.data.data);
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const getKeyByValue = (object, value) => {
    return object.forEach((obj) => {
      if (obj._id == value) {
        let v = obj.lame ? obj.lame : obj.dame;
        
        setSelectName(v);
        setHeader(v);
      }
    });
  };

  useEffect(() => {
    
    setSelectName(selectedName);
    setSelectedLid(lid);
    setHeader(selectedName);
    setLoading(false);

    return () => {};
  }, []);

  useEffect(() => {
    if (loadLineAccess === null) {
      fetchLineAccess();
    }
  }, [loadLineAccess]);

  function InClick() {
    setType("");
    setVisible(false);
    // form.resetFields();
    document.getElementById("inputterReport").focus();
    Fillform.resetFields();
    // form.resetFields();
    setType("IN");
  }

  function OutClick() {
    setType("");
    setVisible(false);
    // form.resetFields();
    document.getElementById("inputterReport").focus();
    Fillform.resetFields();
    // form.resetFields();
    setType("OUT");
  }

  const openNotificationWithIcon = (type, title, desc) => {
    notification[type]({
      message: title,
      description: desc ? desc : null,
    });
  };

  const onFinish = (values) => {
    if (type !== "") {
      form.resetFields();
      document.getElementById("inputterReport").focus();
      setButtonLoading(true);
      liracrypt
        .post("/attendance/scan", {
          lid: selectedLid,
          typ: type,
          rfid: values["scanid"],
        })
        .then((res, req) => {
          if (res.data.data) {
            if (res.data.isSuccess) {
              if (res.data.data) {
                Object.keys(res.data.data).forEach((value) => {
                  
                  Fillform.setFieldsValue({ [value]: res.data.data[value] });
                  setEmpName(res.data.data["eame"]);
                  setRfidValue(res.data.data["eid"]);
                  setYccCatValue(res.data.data["typ"]);
                  setojtStValue(res.data.data["ojtSt"]);
                  setInValue(res.data.data["in"]);
                  setOutValue(res.data.data["out"]);
                });
                setButtonLoading(false);
                openNotificationWithIcon("success", res.data.data.msg);
                setRefresh(!refresh);
                setVisible(true);
                // setType("");
                document.getElementById("inputterReport").focus();
              } else {
                openNotificationWithIcon("error", res.data.data.msg);
                // setType("");
                document.getElementById("inputterReport").focus();
                setButtonLoading(false);
              }
            }
          } else {
            openNotificationWithIcon("error", res.data.message);
            setButtonLoading(false);
           // setType("");
            document.getElementById("inputterReport").focus();
          }
        })
        .catch((err) => {
          setButtonLoading(false);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              // ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else {
      message.error("Please Select Entry Type !");
      setButtonLoading(false);
    }
  };

  const DataBlockArray = () => {
    return (
      <>
        <DemoBlock
          url="/datablock"
          urlData={{ name: "DirectManpower" }}
          tableUrl="/textapi"
          tableData={{ dn: "LineManpowerEmployeeNames" }}
          tableId="Stable"
          title="DirectManpower"
        />

        <DemoBlock
          url="/datablock"
          urlData={{ name: "InDirectManpower" }}
          tableUrl="/textapi"
          tableData={{ dn: "LineManpowerEmployeeNames" }}
          tableId="Stable"
          title="InDirectManpower"
        />

        <DemoBlock
          url="/datablock"
          urlData={{ name: "AuxManpower" }}
          tableUrl="/textapi"
          tableData={{ dn: "LineManpowerEmployeeNames" }}
          tableId="Stable"
          title="AuxManpower"
        />

        <DemoBlock
          url="/datablock"
          urlData={{ name: "AdminManpower" }}
          tableUrl="/textapi"
          tableData={{ dn: "LineManpowerEmployeeNames" }}
          tableId="Stable"
          title="AdminManpower"
        />

        <DemoBlock
          url="/datablock"
          urlData={{ name: "UnassignedManpower" }}
          tableUrl="/textapi"
          tableData={{ dn: "LineManpowerEmployeeNames" }}
          tableId="Stable"
          title="UnassignedManpower"
        />
      </>
    );
  };

  const Display = () => {
    return (
      <Form
        name="ReportForm"
        form={Fillform}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        colon={false}
        onFinish={onFinish}
        size="large"
      >
        <Row gutter={24} justify={window.innerWidth > 700 ? "start" : "center"}>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              name="eame"
              defaultValue={empName}
              label="Name"
              errorMessage="Please Enter ID"
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              name="rfid"
              defaultValue={rfidValue}
              label="Employee ID"
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
        </Row>


        <Row gutter={24} justify={window.innerWidth > 700 ? "start" : "center"}>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              name="typ"
              defaultValue={yccCatValue}
              label="YCC Category"
              errorMessage=""
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              name="ojtSt"
              defaultValue={ojtStValue}
              label="OJT Status"
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
        </Row>




        <Row gutter={24} justify={window.innerWidth > 700 ? "start" : "center"}>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              name="in"
              label="In Time"
              defaultValue={inValue}
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
          <Col span={window.innerWidth > 700 ? 12 : 24}>
            <TextBox
              form={form}
              type="input"
              label="Out Time"
              defaultValue={outValue}
              name="out"
              maxChar={20}
              maxCharErrorMessage="Accepted only 20 Chars"
            />
          </Col>
        </Row>
      </Form>
    );
  };

  return (
    <>
      <SessionError visible={loginError} />
      <div
        style={{
          textAlign: "center",
        }}
      >
        {loadLineAccess ? (
          <>
            {notContent ? (
              <>
                <h3 style={{ color: "#fff" }}>
                  Not Authorized to Access Linedashboard
                </h3>
              </>
            ) : (
              <Select
                id="dropit"
                style={{ width: 200, fontWeight: 600 }}
                placeholder="Select a line"
                optionFilterProp="children"
                defaultValue={selectedLid}
                value={selectName}
                onChange={(value) => {
                  getKeyByValue(loadLineAccess, value);
                  setSelectedLid(value);
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {loadLineAccess.map((obj) => (
                  <Select.Option value={obj._id}>
                    {obj.lame ? obj.lame : obj.dame}
                  </Select.Option>
                ))}
              </Select>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <Spin indicator={antIcon} />
          </div>
        )}
      </div>
      <div
        className="attendanceHead"
        style={{
          margin: "20px",
          borderRadius: "5px",
          padding: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: 0,
          boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
          borderRadius: "10px",
          fontWeight: "600",
        }}
      >
        <h1
          style={{
            fontSize: window.innerWidth > 700 ? "3rem" : "1.5rem",
            color: "#fff",
            fontWeight: "700",
            margin: "1rem",
          }}
        >
          {loading ? <Spin indicator={antIconHeader} /> : header}
        </h1>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* {refresh ? <DataBlockArray /> : <DataBlockArray />} */}
        {/* <DataBlockArray /> */}
      </div>

      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}
      >
        <div
          onClick={(e) => {
            InClick();
          }}
          style={{
            ...buttonStyle,
            backgroundColor: type === "IN" ? "#52c41a" : "#808080",
            border: 0,
            boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            borderRadius: "10px",
            fontWeight: "600",
          }}
        >
          <span style={{ fontSize: "3rem", padding: "1rem" }}>IN</span>
        </div>
        <div
          onClick={() => OutClick()}
          style={{
            ...buttonStyle,
            backgroundColor: type === "OUT" ? "#dc3545" : "#808080",
            border: 0,
            boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            borderRadius: "10px",
            fontWeight: "600",
          }}
        >
          <span style={{ fontSize: "3rem", padding: "1rem" }}>OUT</span>
        </div>
      </div>

      <div
        className="AuditSection CreateAudit"
        style={{ padding: "10px", marginTop: "40px" }}
      >
        <div className="ThemeForm" style={{ opacity: 0 }}>
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row gutter={24} justify="center">
              <Col span={22}>
                <TextBox
                  form={form}
                  id="inputterReport"
                  type="input"
                  name="scanid"
                  label="User ID"
                  required={true}
                  errorMessage="Please Enter ID"
                  maxChar={20}
                  maxCharErrorMessage="Accepted only 20 Chars"
                />
              </Col>
              <Col>
                <Button
                  type="primary"
                  size="large"
                  style={{
                    fontWeight: 600,
                    width: "100%",
                    display: "none",
                  }}
                  htmlType="submit"
                >
                  {buttonLoading ? <Spin indicator={antIcon} /> : "OK"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      <div
        className="AuditSection CreateAudit"
        style={{
          padding: "10px",
          // marginTop: window.innerWidth > 700 ? "40px" : "0px",
          // marginLeft: "15px",
          visibility: visible ? "visible" : "hidden",
          textAlign: "center",
        }}
      >
        <div className="ThemeForm">
          <Display />
        </div>
      </div>
    </>
  );
}

export default LineAttendance;
